import styled from 'styled-components';
import { theme } from '../../styles/themes/default';

export const Text = styled.p`
  color: ${theme.colors.grey[600]};
`;
